module.exports = __webpack_public_path__ + "media/images/home/flow_p_2-2a6e37a5986821876b5964f1b1bfbb69.svg";